/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: 'us-east-1',
  aws_cognito_identity_pool_id: 'us-east-1:91b6a5d6-5060-472a-b433-3d671b45ed19',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_AzwFlIZlW',
  aws_user_pools_web_client_id: '1dtoenjchihbangn8bmjqnc0h3',
  oauth: {}
};


export default awsmobile;
